module.exports = __webpack_public_path__ + "static/media/prospectdup.b0ef2dfb.png";